import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato recibo el material?',
  a: 'Recibís todo en formato PDF digital. Podés abrirlo desde tu celular, tablet o computadora.'
}, {
  q: '¿Cuánto tarda en llegar después de pagar?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, recibís la información de acceso y entrega.'
}, {
  q: '¿Necesito experiencia previa en marketing?',
  a: 'No. El material está pensado para personas que quieren empezar desde cero o mejorar lo que ya vienen haciendo.'
}, {
  q: '¿Funciona para productos físicos y servicios?',
  a: 'Sí. El sistema está pensado para emprendedores que venden productos, ofrecen servicios o quieren empezar a vender online de forma más ordenada.'
}, {
  q: '¿Necesito invertir mucho en anuncios?',
  a: 'No necesariamente. El material también está pensado para ayudarte a entender cómo empezar de forma controlada y con criterio.'
}, {
  q: '¿Qué pasa si compro y no me sirve?',
  a: 'Tenés una garantía de 7 días. Si sentís que no era para vos, podés pedir la devolución dentro de ese plazo.'
}, {
  q: '¿El acceso tiene vencimiento?',
  a: 'No. El acceso al material es de por vida.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Eso depende del medio de pago disponible al momento de comprar, especialmente si abonás con tarjeta a través de Mercado Pago.'
}, {
  q: '¿Tiene soporte si tengo dudas?',
  a: 'Sí. Podés escribir a soporteguiadigital360@gmail.com'
}, {
  q: '¿Funciona si vivo fuera de Argentina?',
  a: 'Sí. El contenido puede aplicarse desde otros países, aunque algunas herramientas o ejemplos pueden estar orientados a Argentina y Latam.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-20 px-4 bg-green-950/30 border-t border-green-700/20" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12" data-id="element-49">
          <h2 className="text-3xl sm:text-4xl font-black text-white flex items-center justify-center gap-3 drop-shadow-lg uppercase" data-id="element-50">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-green-950/50 border border-green-700/20 rounded-xl overflow-hidden" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-53">
                <span className="font-bold text-white pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-yellow-300 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>
              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-white/80 font-medium leading-relaxed border-t border-white/5 pt-4" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}